import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { FilterExpandSettings } from "@progress/kendo-angular-treeview";
import { UserService } from "src/app/admin/user/shared/services/user.service";
import { LocationUsersDropDownModel } from "../../models/users-drop-down-list.model";
/**
 * UsersDropDownSelectTreeViewComponent - A sample drop down tree view to with checkbox to select locations
 * To create drop down menu, following data fields should be avialable in your custom data objects.
 *
 * rootLocations    : array of root locations Ids or [-1] to select all root locations
 * selectItem       : Selected users Ids/ Names as json object - Eg: {name: 'Display Name',id: 1}, set empty for none eg: {}
 * userSelectEvent  : Event on a user select
 */
@Component({
    selector: "users-drop-down-select-tree-view",
    styleUrls: ['./user-drop-down-select-tree-view-component.css'],
    templateUrl: './users-drop-down-select-tree-view-component.html',
})

export class UsersDropDownSelectTreeViewComponent implements OnChanges, OnInit {

    readonly defaultSelection = {
        fullName: 'Select',
        userId: -1,
    };

    // Selected value
    public selectedUser = this.defaultSelection;
    public searchKeyWord = "";
    public users: any[] = [];

    // get checked components Tree view unique id
    @Input() selectItem: any = this.defaultSelection;

    @Output() userSelectEvent = new EventEmitter<LocationUsersDropDownModel>();

    public valueChange(value: any) {
        this.userSelectEvent.emit(value ?? { fullName: 'Select', userId: -1 });
    }

    constructor(private userService: UserService) { }

    public ngOnInit(): void {
        this.userService.getUsersByHomeLocation().subscribe((response: any[]) => {
            this.users = response;
        });

        this.selectedUser = this.selectItem;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.selectedUser = this.selectItem;
    }

    public filterExpandSettings: FilterExpandSettings = {
        maxAutoExpandResults: 5
    };

    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: "contains",
    };
}
